// eslint-disable-next-line @typescript-eslint/ban-types
export function functionBodyToString(f, argumentNames) {
    return `return (${f.toString()})(${argumentNames})`;
}
